module.exports = __webpack_public_path__ + "static/media/home-03.40d43a62.webm";